import {asCreator, withCallbacks} from "../../../../lib/utils";
import {compose} from '../../../../utils/functions';
import {actionTypes} from "../../reducers/authReducer";

export const getUser = compose(
    withCallbacks,
    asCreator(() => ({
        type: actionTypes.GET_USER,
    }))
)